import { statsResource } from 'features/account/state/accountSlice'
import { useResource } from 'app/state/resource'
import { useAppSelector } from 'app/state'

function useAccountHasMaps() {
  const maps = useAppSelector((state) => state.maps.myMaps)
  const { data: stats, isLoading: loading } = useResource(statsResource)

  return { loading, accountHasMaps: (stats !== undefined && stats?.totalMaps > 0) || maps.length > 0 }
}

export default useAccountHasMaps
